var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 66,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "390 213 59 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.238 36 35.524",
    fill: "#333",
    x: 402,
    y: 213,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0.237 0.5 35.176 34.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M17.825 35.21c9.699 0 17.588-7.785 17.588-17.355S27.523.5 17.825.5C8.128.5.237 8.285.237 17.855s7.89 17.356 17.588 17.356zm0-32.802c8.632 0 15.655 6.93 15.655 15.447 0 8.518-7.023 15.448-15.655 15.448S2.171 26.373 2.171 17.855c0-8.517 7.022-15.447 15.654-15.447z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.172 26 25.656",
    fill: "#333",
    x: 407,
    y: 218,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0.105 0.304 25.44 25.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M12.825 25.407c7.014 0 12.72-5.63 12.72-12.552 0-6.92-5.706-12.551-12.72-12.551-3.165 0-6.2 1.155-8.543 3.252a.945.945 0 0 0-.066 1.348c.358.39.97.42 1.365.066a10.84 10.84 0 0 1 7.244-2.758c5.947 0 10.787 4.775 10.787 10.643 0 5.869-4.84 10.644-10.787 10.644-5.947 0-10.785-4.775-10.785-10.644 0-1.772.45-3.526 1.3-5.072a.947.947 0 0 0-.388-1.294.974.974 0 0 0-1.311.383 12.44 12.44 0 0 0-1.536 5.983c0 6.921 5.707 12.552 12.72 12.552z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.106 0 8.787 18",
    fill: "#333",
    opacity: 0.451,
    x: 415,
    y: 222,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9,
    height: 18,
    viewBox: "0.542 0.781 8.107 16.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M4.457 13.35c-1.518-.091-1.935-.993-2.012-1.205a.966.966 0 0 0-.935-.708.962.962 0 0 0-.968.956c0 .076.01.15.027.222l.005.018c.011.045.025.09.044.132.178.487.895 1.997 3.007 2.4v1.27a.96.96 0 0 0 .966.954.96.96 0 0 0 .967-.954v-1.241c.926-.16 1.548-.558 1.936-.92.723-.67 1.155-1.686 1.155-2.715 0-.966-.385-3.257-3.944-3.644-.704-.077-1.207-.298-1.495-.658a1.318 1.318 0 0 1-.28-.805c0-.168.046-1.64 1.661-1.64 1.06 0 1.488.665 1.568.81.143.351.491.6.899.6a.962.962 0 0 0 .968-.957.948.948 0 0 0-.107-.435c-.273-.585-1.042-1.5-2.36-1.814v-1.28A.96.96 0 0 0 4.59.78a.961.961 0 0 0-.967.954v1.277C1.716 3.459.996 5.216.996 6.452c0 1.374.916 3.078 3.498 3.36 2.22.241 2.22 1.375 2.22 1.747 0 .396-.143.952-.546 1.326-.38.354-.956.51-1.71.465z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.153 0 15.695 22",
    fill: "#333",
    x: 395,
    y: 257,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 22,
    viewBox: "0.181 0.378 15.068 21.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M8.42.679a.972.972 0 0 0-1.41 0L.444 7.569A.945.945 0 0 0 .261 8.6c.153.35.501.576.887.576h1.898v3.464a.96.96 0 0 0 .967.954.961.961 0 0 0 .967-.954V8.222a.961.961 0 0 0-.967-.954h-.628l4.33-4.543 4.33 4.543h-.628a.96.96 0 0 0-.966.954v11.37H4.979v-3.136a.96.96 0 0 0-.966-.954.96.96 0 0 0-.967.954v4.09a.96.96 0 0 0 .967.954h7.404a.96.96 0 0 0 .967-.954V9.176h1.898a.969.969 0 0 0 .888-.576.946.946 0 0 0-.183-1.032L8.419.678z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.108 0 15.784 29",
    fill: "#333",
    x: 412,
    y: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 29,
    viewBox: "0.291 0.815 15.069 27.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M8.53 1.115a.972.972 0 0 0-1.41 0L.555 8.005A.943.943 0 0 0 .37 9.037c.153.35.501.576.887.576h1.898v17.933a.96.96 0 0 0 .967.954h7.404a.96.96 0 0 0 .967-.954V9.613h1.898a.969.969 0 0 0 .888-.576.945.945 0 0 0-.183-1.032l-6.568-6.89zm2.997 6.59a.96.96 0 0 0-.966.954v17.933H5.089V8.658a.96.96 0 0 0-.966-.954h-.628l4.33-4.543 4.33 4.543h-.628z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.188 0 15.623 35",
    fill: "#333",
    x: 429,
    y: 244,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 35,
    viewBox: "0.401 0.742 15.069 33.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M8.64 1.043a.972.972 0 0 0-1.41 0L.665 7.933A.945.945 0 0 0 .48 8.963c.154.35.502.576.888.576h1.898v5.822a.96.96 0 0 0 .967.954.96.96 0 0 0 .966-.954V8.586a.96.96 0 0 0-.966-.954h-.628l4.33-4.543 4.33 4.543h-.628a.96.96 0 0 0-.966.954v24.006H5.199V19.178a.96.96 0 0 0-.966-.954.96.96 0 0 0-.967.954v14.368a.96.96 0 0 0 .967.954h7.404a.96.96 0 0 0 .967-.954V9.54h1.898a.969.969 0 0 0 .888-.576.946.946 0 0 0-.183-1.032l-6.568-6.89z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 3,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.371 9 2.258",
    fill: "#333",
    opacity: 0.451,
    x: 390,
    y: 230,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9,
    height: 3,
    viewBox: "1 0.243 7.604 1.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M8.604 1.197a.96.96 0 0 0-.968-.954h-5.67A.96.96 0 0 0 1 1.197a.96.96 0 0 0 .966.954h5.67a.96.96 0 0 0 .968-.954z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 4,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.299 5 3.402",
    fill: "#333",
    opacity: 0.451,
    x: 396,
    y: 238,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 4,
    viewBox: "0.256 0.618 3.951 2.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M2.888.684l-2.018.78a.95.95 0 0 0-.547 1.235.967.967 0 0 0 1.253.54l2.017-.779a.95.95 0 0 0 .547-1.236.97.97 0 0 0-1.252-.54z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 3,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.295 0 4.41 3",
    fill: "#333",
    opacity: 0.451,
    x: 396,
    y: 221,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 3,
    viewBox: "0.256 0.087 3.951 2.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.871 1.93l2.017.78a.972.972 0 0 0 1.252-.54.95.95 0 0 0-.547-1.237L1.576.153a.97.97 0 0 0-1.253.54.95.95 0 0 0 .548 1.237z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 3,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.371 9 2.258",
    fill: "#333",
    opacity: 0.451,
    x: 440,
    y: 230,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9,
    height: 3,
    viewBox: "0.595 0.243 7.604 1.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M7.232.243h-5.67a.96.96 0 0 0-.967.954.96.96 0 0 0 .968.954h5.67a.96.96 0 0 0 .966-.954.96.96 0 0 0-.967-.954z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 4,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.299 5 3.402",
    fill: "#333",
    opacity: 0.451,
    x: 438,
    y: 238,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 4,
    viewBox: "0.992 0.618 3.951 2.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M1.606 2.46l2.016.78a.976.976 0 0 0 1.254-.54.95.95 0 0 0-.548-1.236L2.31.684a.97.97 0 0 0-1.252.54.95.95 0 0 0 .547 1.236z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 3,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.295 0 4.409 3",
    fill: "#333",
    opacity: 0.451,
    x: 438,
    y: 221,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 3,
    viewBox: "0.992 0.087 3.951 2.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M1.96 2.775a.972.972 0 0 0 .351-.065l2.017-.78A.95.95 0 0 0 4.876.694a.972.972 0 0 0-1.254-.54L1.606.932a.95.95 0 0 0-.547 1.236c.15.377.514.606.9.606z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.2a65759c749f24b9407ef92f2da3940c.svg";
export { ForwardRef as ReactComponent };